import { StateLock } from 'zova';
export class IconGroup {
  constructor() {
    this.svg = void 0;
    this.loaded = void 0;
    this.loaded = StateLock.create();
  }
}